// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__BO0GF","head":"Table_head__11b_k","col":"Table_col__1JZS_"};